import React from 'react'
import useTranslation, {
  TranslationProvider,
} from '~/components/shared/TranslationProvider'
import * as translations from './locales.json'
import { MessagingProvider, useMessaging } from './MessagingProvider'
import { BrowserRouter } from 'react-router-dom'
import { Button } from '~/lib/ui/button'
import Layout from './Layout'
import { TabNav, ButtonContainer, TabButton } from '~/components/shared/TabNav'

const BronzeText = () => {
  const { t } = useTranslation('index')

  return <>{t('view_and_create_messages_bronze')}</>
}
const SilverText = () => {
  const { t } = useTranslation('index')

  return <>{t('view_and_create_messages_silver')}</>
}
const GoldText = () => {
  const { t } = useTranslation('index')

  return <>{t('view_and_create_messages_gold')}</>
}
const CoachText = () => {
  const { t } = useTranslation('index')

  return <>{t('messaging_instructions_coaching_for_staff')} </>
}

const MainView = () => {
  const {
    isMobile,
    currentThreadId,
    newMessageMode,
    setNewMessageMode,
    clearNewMessageMode,
    userIsCoach,
    programIsBronze,
    programIsSilver,
    programIsGold,
  } = useMessaging()

  const handleNewMessage = () => {
    userIsCoach
      ? (window.location.href = '/coach/op_candidates')
      : setNewMessageMode(true)
  }

  const isThreadView = !currentThreadId && !newMessageMode

  const showBackButton = isMobile && !isThreadView

  const onChangeActiveTab = (activeTab) => {
    if (activeTab === 'reminders') {
      window.location.href = '/reminders'
    }
  }

  const { t } = useTranslation('index')

  return (
    <>
      <div className="mx-4 mt-4 flex flex-col justify-between md:mx-9">
        <div className="flex flex-col justify-between gap-4 md:flex-row">
          <h1 className="mt-4 !text-intoo-green-coachcta">
            {userIsCoach ? (
              <>{t('messages')}</>
            ) : (
              <>
                <span className="pr-2 font-normal">{t('view_your')}</span>
                {t('messages')}
              </>
            )}
          </h1>
        </div>
        <div>
          {userIsCoach && <CoachText />}
          {programIsBronze && <BronzeText />}
          {programIsSilver && <SilverText />}
          {programIsGold && <GoldText />}
        </div>
        {!newMessageMode && isMobile && !userIsCoach && (
          <Button
            className="mt-4 w-full hover:text-white focus:text-white"
            variant="coachcta"
            onClick={handleNewMessage}
          >
            {t('create_message')}
          </Button>
        )}
        {!userIsCoach && (
          <TabNav
            defaultActiveTab="messages"
            mobileMode="swipe"
            className="my-4 md:flex md:flex-row md:justify-between md:border-b md:border-solid md:border-[#979797]"
            onChangeActiveTab={onChangeActiveTab}
          >
            <ButtonContainer className="justify-start md:border-none">
              <TabButton
                name="messages"
                text={t('messages_tab_heading')}
                activeDecorationClass="bg-intoo-green-coachcta"
              />
              <TabButton name="reminders" text={t('reminders_tab_heading')} />
            </ButtonContainer>
            {!isMobile && (
              <Button
                className="w-auto hover:text-white focus:text-white"
                variant="coachcta"
                onClick={handleNewMessage}
              >
                {t('create_message')}
              </Button>
            )}
          </TabNav>
        )}
        {showBackButton && (
          <div>
            <Button
              asChild
              variant="outline"
              className="mb-4 w-full text-cod-gray-700 hover:text-cod-gray-700"
            >
              <a onClick={clearNewMessageMode} href="#">
                Back to All Messages
                {t('back_to_all_messages')}
              </a>
            </Button>
          </div>
        )}
      </div>
      <Layout />
    </>
  )
}

const CoachMessaging = ({ locale, ...props }) => {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <TranslationProvider
        locale={locale}
        translations={translations}
        scope={'javascript.components.CoachMessaging'}
      >
        <MessagingProvider {...props}>
          <MainView />
        </MessagingProvider>
      </TranslationProvider>
    </BrowserRouter>
  )
}

export default CoachMessaging
